(function () {
    'use strict';

    angular.module("imApp").factory("docArticleMenuService", ['$ihttp', function ($ihttp) {
        var service = {};

        return service;
    }]);
})();